import { render, staticRenderFns } from "./StudentReport.vue?vue&type=template&id=05751630&scoped=true"
import script from "./StudentReport.vue?vue&type=script&lang=js"
export * from "./StudentReport.vue?vue&type=script&lang=js"
import style0 from "./StudentReport.vue?vue&type=style&index=0&id=05751630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05751630",
  null
  
)

export default component.exports